import React, { useEffect, useMemo } from "react";
import clsx from "clsx";
import { useFormContext, useFieldArray } from "react-hook-form";

import { Button } from "components";
import { BillToTypes, BillingStatusTypes, PaymentTypes } from "types";

import PaymentMethod from "./paymentMethod";

import styles from "../../terminalSolution.module.scss";

type BillSectionProps = {
	isLoading: boolean;
	sectionName?: string;
	merchantInfo: { [key: string]: any };

	defaultValues?: { [key: string]: any };
};

// This component is used only on merchant, tid.
const BillSection = ({
	isLoading,
	sectionName = "paymentMethods",
	merchantInfo,
	defaultValues,
}: BillSectionProps) => {
	const { control, setValue } = useFormContext();

	const { fields, append, remove } = useFieldArray({
		control,
		name: sectionName,
	});

	const defaultBillTo = useMemo(
		() => ({
			billToInfo: {
				billTo: BillToTypes.merchant.value?.toString(),
				amountToBeBilled: "",
			},
			paymentTypeInfo: {
				paymentType: PaymentTypes.ach.name,
				billingStatus: BillingStatusTypes.pending,
				invoiceDate: "",
				paymentDate: "",
			},
			paymentMethodId: "",
			paymentMethod: "",
			paymentMethodChosenId: "",
		}),
		[],
	);

	useEffect(() => {
		if (fields.length === 0 && defaultValues?.length > 0) {
			setValue(sectionName, defaultValues);
		}
	}, [defaultValues, fields, sectionName, setValue]);

	const addPayeeSection = () => {
		append(defaultBillTo);
	};

	return (
		<div data-autotest={sectionName}>
			<hr className={clsx(styles.divider, "mt-3 mb-4")} />
			<p className={styles.subHeader}>Bill To / Payment Methods</p>
			{fields?.map((paymentMethod: { [key: string]: any }, index) => {
				return (
					<React.Fragment key={paymentMethod?.id}>
						<PaymentMethod
							data={paymentMethod}
							index={index}
							sectionName={sectionName}
							isLoading={isLoading}
							merchantInfo={merchantInfo}
							removePayment={remove}
						/>
					</React.Fragment>
				);
			})}
			<Button
				value="Add Payee"
				minWidth="auto"
				className="px-0"
				variant="secondary"
				onClick={addPayeeSection}
			/>
		</div>
	);
};

export default BillSection;
